import { Sketch } from '@uiw/react-color';

import { produce } from 'immer';

export default function ColourPickerInputs({ keys, styleName, styleObj, setStyle, styles, stringFormatter = (string) => string }) {
  return (
    <div className="d-flex flex-column gap-3">
      {keys.map((item) => {
        const key = item.key;
        const label = item.label;
        const collapseId = `color-collapse-${key}`;
        const headerId = `color-header-${key}`;
        return (
          <div key={key} className="mb-2">
            <label>
              <b>{label}</b>
            </label>
            <div className="accordion accordion-flush" id={`accordion-${key}`}>
              <div className="accordion-item">
                <h2 className="accordion-header" id={headerId}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${collapseId}`}
                    aria-expanded="false"
                    aria-controls={collapseId}
                  >
                    <div style={{ backgroundColor: styleObj[key], height: 24, width: 24 }} />
                    <span className="ms-3">{styleObj[key]}</span>
                  </button>
                </h2>
                <div id={collapseId} className="accordion-collapse collapse" aria-labelledby={headerId} data-bs-parent={`#accordion-${key}`}>
                  <div className="accordion-body">
                    <div className="d-flex justify-content-center">
                      <Sketch
                        style={{ marginLeft: 20 }}
                        color={styleObj[key]}
                        onChange={(colour) =>
                          setStyle(
                            produce(styles, (draft) => {
                              draft[styleName][key] = colour.hexa;
                            }),
                          )
                        }
                      />
                      <div className="d-flex flex-column align-items-center justify-content-center ms-3">
                        <div
                          style={{
                            backgroundColor: styleObj[key],
                            height: 100,
                            width: 100,
                            borderRadius: '50%',
                          }}
                          aria-label={`Color preview for ${key}: ${styleObj[key]}`}
                        />
                        <span>{styleObj[key]}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-muted mt-2 mb-0">{item.description}</p>
          </div>
        );
      })}
    </div>
  );
}
